import React, { useEffect, useState } from "react";
import { Menu, Button, Input, VisuallyHidden } from "@chakra-ui/react";
import { UseFormRegister, UseFormSetValue } from "react-hook-form";
import { ChevronDown } from "lucide-react";
import {
  NFTTokenDeclaration,
  useChainbridge,
} from "../../Contexts/ChainbridgeContext";

interface ITokenSelectInput {
  className?: string;
  name: string;
  nftTokens: NFTTokenDeclaration[];
  sync?: (value: NFTTokenDeclaration) => void;
  options: Array<object>; // Could be better
  isDisabled: boolean;
  register: UseFormRegister<any>;
  value: string;
  setValue: UseFormSetValue<any>;
}

const NFTTokenSelectInput: React.FC<ITokenSelectInput> = ({
  name,
  nftTokens,
  sync,
  options,
  isDisabled,
  register,
  setValue,
  value,
}: ITokenSelectInput) => {
  const { getTotalTokensOwnedForNFT } = useChainbridge();

  const [selectedToken, setSelectedToken] =
    React.useState<NFTTokenDeclaration>();
  const [selectedTokenBalance, setSelectedTokenBalance] =
    React.useState<number>(-1);
  const [selectedTokenAddress, setSelectedTokenAddress] =
    React.useState<string>("");

  useEffect(() => {
    async function fetchData() {
      if (!selectedToken) {
        return;
      }

      setSelectedTokenAddress(selectedToken.address);

      const balance = await getTotalTokensOwnedForNFT(selectedToken.contract);

      setSelectedTokenBalance(balance);
    }

    fetchData();
  }, [selectedToken]);

  const handleClick = (selectedValue: string) => {
    setValue(name, selectedValue, { shouldValidate: true }); // Form validation

    let selectedDeclaration = nftTokens.filter((declaration) => {
      return declaration.address == selectedValue;
    })[0];
    setSelectedToken(selectedDeclaration);
  };

  const labelParsed =
    value !== "" && selectedToken
      ? `${selectedToken.symbol} (${Math.max(
          selectedTokenBalance as number,
          0
        )} Owned)`
      : "Please select token";

  const tokenAddressValidator = register(name);

  const [synced, setSynced] = useState<NFTTokenDeclaration>();
  useEffect(() => {
    if (!selectedToken) {
      return;
    }
    if (sync && selectedToken.address !== synced?.toString()) {
      setSynced(selectedToken);
      if (selectedToken) {
        sync(selectedToken);
      }
    }
    // eslint-disable-next-line
  }, [selectedToken]);

  useEffect(() => {
    if (value === "") {
      setSelectedTokenAddress("");
      setSelectedToken(undefined);
    }
  }, [value]);

  return (
    <section>
      <Menu.Root>
        <Menu.Trigger asChild>
          <Button width="100%" disabled={isDisabled}>
            {labelParsed} <ChevronDown size={16} />
          </Button>
        </Menu.Trigger>
        <Menu.Positioner>
          <Menu.Content borderRadius="0px" border="1px solid" width="100%">
            {options.map((option: any, index) => {
              // TODO: remove this any
              return (
                <Menu.Item
                  value={option.value}
                  onClick={handleClick.bind(this, option.value)}
                  key={"option" + index}
                >
                  {option.label}
                </Menu.Item>
              );
            })}
          </Menu.Content>
        </Menu.Positioner>
      </Menu.Root>
      {/* Hidden text field for form validation: */}
      <VisuallyHidden>
        <Input
          name={name}
          value={selectedTokenAddress}
          onChange={tokenAddressValidator.onChange}
          onBlur={tokenAddressValidator.onBlur}
          ref={tokenAddressValidator.ref}
        />
      </VisuallyHidden>
    </section>
  );
};

export default NFTTokenSelectInput;
